<template>
  <div class="ac-card-content">
    <div class="ac-header-container">
      <div class="ac-header">
        Change Partner
      </div>
      <button
        type="button"
        class="ac-close-button"
        @click="toggleActionModal(false)"
      >
        <img
          src="@shared/assets/img/general/x-black.png"
          alt="x"
          class="ac-close"
        >
      </button>
    </div>
    <div class="ac-body-container">
      <div class="flex-column margin-bottom-4 margin-top-8">
        <b>Current Partner:</b>
        <span>
          {{ customer.companyName }}
        </span>
      </div>
      <div
        v-if="loadingPartners"
        class="loading-container margin-bottom-4"
      >
        <img
          alt="Loading"
          src="@shared/assets/img/general/loading.svg"
        >
      </div>
      <div
        v-else
        class="flex-column margin-bottom-4"
      >
        <b>New Partner:</b>
        <SACDropdown
          placeholder="Select New Partner"
          :options="partnerOptions"
          :value="selectedPartner"
          :change="(field, value) => selectPartner(value)"
          :error="errObj.pleaseSelect"
        />
      </div>
      <template v-if="selectedPartner > 0">
        <div
          v-if="loadingPlans"
          class="loading-container margin-bottom-4"
        >
          <img
            alt="Loading"
            src="@shared/assets/img/general/loading.svg"
          >
        </div>
        <div
          v-else-if="planOptions.length > 0"
          class="flex-column margin-bottom-4"
        >
          <b>New SMART MAINTENANCE® Plan:</b>
          <SACDropdown
            placeholder="Select New Plan"
            :options="planOptions"
            :value="selectedProviderPlan"
            :change="(field, value) => selectPlan(value)"
          />
        </div>
        <div
          v-else
          class="flex-column margin-bottom-4"
        >
          There are no SMART MAINTENANCE® plans to add
        </div>
      </template>
    </div>
    <div
      v-if="!loadingPlans"
      class="ac-footer-container"
    >
      <button
        type="button"
        class="ac-form-button"
        @click="toggleActionModal(false)"
      >
        Close
      </button>
      <button
        type="button"
        class="ac-form-button"
        @click="updateCustomerProviderPlan"
      >
        Save
      </button>
    </div>
    <ProcessOverlay :show="updating" />
  </div>
</template>

<script>
import apiClient from '@shared/lib/general/apiClient';

import customerDetailMixin from '@shared/mixins/customerDetailMixin';

import ProcessOverlay from '@shared/components/ProcessOverlay.vue';
import SACDropdown from '../../sac/SACDropdown.vue';

export default {
  name: 'ChangePartner',
  components: {
    SACDropdown,
    ProcessOverlay,
  },
  mixins: [customerDetailMixin],
  data() {
    return {
      partners: [],
      plans: [],
      selectedPartner: -1,
      selectedProviderPlan: -1,
      loadingPartners: true,
      loadingPlans: true,
      updating: false,
      errObj: {},
    };
  },
  computed: {
    partnerOptions() {
      return this.partners.map((p) => ({
        label: p.corporationName,
        value: p.id,
      }));
    },
    planOptions() {
      return this.plans.map((p) => ({
        label: p.name,
        value: p.planId,
      }));
    },
  },
  mounted() {
    this.getActivePartners();
  },
  methods: {
    async getActivePartners() {
      try {
        const { data: partners } = await apiClient({
          method: 'POST',
          url: '/corporations/query/',
          data: {
            accountStatuses: ['Active'],
          },
        });

        partners.sort((a, b) => {
          if (a.corporationName < b.corporationName) {
            return -1;
          }
          if (a.corporationName > b.corporationName) {
            return 1;
          }
          return 0;
        });

        this.partners = partners;
        this.loadingPartners = false;
      } catch (err) {
        console.error(err);
      }
    },
    async getPartnerPlans(corpId) {
      try {
        const { data } = await apiClient({
          method: 'GET',
          url: `/provider/plans/corp/${corpId}/all`,
        });

        this.plans = data;
        this.loadingPlans = false;
      } catch (err) {
        console.error(err);
      }
    },
    async updateCustomerProviderPlan() {
      const errObj = {};
      if (!this.selectedPartner) {
        errObj.pleaseSelect = 'Please select a plan';
      }
      this.errObj = errObj;
      if (Object.keys(errObj).length === 0) {
        this.updating = true;
        await this.$store.dispatch('transferPartner', {
          id: this.customer.id,
          corporationId: this.selectedPartner,
          providerPlanId: this.selectedProviderPlan,
        });
        this.$store.dispatch('showSuccessToast', {
          message: 'Success! Member has been transferred',
        });
        this.updating = false;
        this.toggleActionModal(false);
      }
    },
    selectPartner(value) {
      this.selectedPartner = value;
      this.getPartnerPlans(value);
    },
    selectPlan(value) {
      this.selectedProviderPlan = value;
    },
  },
};
</script>
